import { render, staticRenderFns } from "./PupilDashboard.vue?vue&type=template&id=6f1cc396&scoped=true"
import script from "./PupilDashboard.vue?vue&type=script&lang=ts"
export * from "./PupilDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1cc396",
  null
  
)

export default component.exports